
/**
 * Utility for exporting data to CSV format
 */

/**
 * Downloads an array of objects as a CSV file
 * 
 * @param data Array of objects to convert to CSV
 * @param filename Name of the file to download (without extension)
 */
export function downloadAsCSV(data: Record<string, any>[], filename: string): void {
  if (!data || data.length === 0) {
    console.error('No data to export');
    return;
  }

  // Get headers from the first object
  const headers = Object.keys(data[0]);
  
  // Convert data to CSV rows
  const csvRows = [
    // Header row
    headers.join(','),
    // Data rows
    ...data.map(row => {
      return headers.map(header => {
        // Handle values that might contain commas
        const cell = row[header] === null || row[header] === undefined ? '' : row[header].toString();
        if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
          return `"${cell.replace(/"/g, '""')}"`;
        }
        return cell;
      }).join(',');
    })
  ];
  
  // Combine all rows into a single CSV string with newlines
  const csvString = csvRows.join('\n');
  
  // Create a blob from the CSV string
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  
  // Create a download link and trigger a click
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Downloads data in JSON format
 * 
 * @param data Data to be exported as JSON
 * @param filename Name of the file to download (without extension)
 */
export function downloadAsJSON(data: any, filename: string): void {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.json`);
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
